import { useState } from "react";
import { motion } from "framer-motion";
import KeeperEntrance from "./KeeperEntrance";

export default function Footer() {
    const [showCard, setShowCard] = useState(false);

    return (
        <footer data-testid="footer" className="relative z-10 border-t border-[rgba(212,175,55,0.15)] px-6 py-16 text-center">
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1 }}
            >
                <p className="font-cinzel text-sm tracking-[0.35em] text-[#b89860] uppercase">
                    <a
                        href="https://firstcameeve.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-domain-link"
                        className="transition-colors duration-300 hover:text-[#f3e5ab]"
                    >
                        FirstCameEve.com
                    </a>
                </p>

                <button
                    data-testid="share-card-button"
                    onClick={() => setShowCard((v) => !v)}
                    className="btn-eden mt-8 rounded-sm bg-transparent px-6 py-3 text-[0.65rem] text-[#d4af37]"
                >
                    {showCard ? "Hide the Card" : "Share the Story"}
                </button>

                {showCard && (
                    <motion.img
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        src="/assets/business-card.png"
                        alt="Eve Came First — Coming Soon share card"
                        data-testid="share-card-image"
                        className="book-glow mx-auto mt-8 w-full max-w-md rounded-md"
                    />
                )}

                <p
                    className="font-cinzel mt-12 text-[0.7rem] tracking-[0.35em] text-[#e8c888] uppercase [text-shadow:0_2px_14px_rgba(0,0,0,0.95)]"
                    data-testid="contact-heading"
                >
                    Contact Author
                </p>
                <a
                    href="mailto:FirstCameEve@gmail.com"
                    data-testid="contact-email-link"
                    className="font-cormorant mt-3 inline-block text-xl italic text-[#e8d5a8] transition-colors duration-300 hover:text-[#f3e5ab]"
                >
                    FirstCameEve@gmail.com
                </a>

                <div
                    className="mx-auto mt-12 max-w-xs rounded-sm border border-[rgba(212,175,55,0.3)] bg-[rgba(15,35,24,0.9)] px-6 py-4 backdrop-blur-md"
                    data-testid="footer-legal-card"
                >
                    <p className="font-cinzel text-[0.6rem] tracking-[0.25em] text-[#d4af37] uppercase">
                        Victor M Medina &nbsp;·&nbsp; Eve Came First
                    </p>
                    <p className="font-cinzel mt-2 text-[0.55rem] leading-relaxed tracking-[0.18em] text-[#a3b899] uppercase">
                        © 2026 Medina Legacy Ventures LLC &nbsp;·&nbsp; All Rights Reserved
                    </p>
                </div>

                <KeeperEntrance />
            </motion.div>
        </footer>
    );
}
